<template>
    <div class="container-fluid">
        <div class="row justify-content-center">
            <div class="col-12">
                <!-- Header -->
                <div class="header mt-md-5">
                    <div class="header-body">
                        <div class="row align-items-center">
                            <div class="col">
                                <h6 class="header-pretitle">{{$t('Company')}}</h6>
                                <h1 class="header-title">{{$t('Trash')}}</h1>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
        <div class="row">
            <div class="col-3">
                <div class="card">
                    <div class="card-body">
                        <div v-for="(key, index) in Object.keys(tables)" :key="index">
                            <div class="row align-items-center pointer">
                                <div class="col-1" v-if="tab === key" @click="tab=null">
                                    <span class="fe fe-x text-muted"></span>
                                </div>
                                <div class="col" @click.prevent="tab=key">
                                    <h4 class="card-title mb-1">
                                        <a href="#">
                                            <i class="fe" :class="tables[key].icon"></i>
                                            <span class="ml-2">{{$t(tables[key].label)}}</span>
                                        </a>
                                    </h4>
                                </div>
                                <div class="col-auto">
                                    <span class="badge badge-pill badge-soft-primary">{{tables[key].count}}</span>
                                </div>
                            </div>
                            <hr/>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-9">
                <div class="card" data-toggle="lists">
                    <div class="card-body p-3">
                        <div class="row align-items-center">
                            <div class="col">
                            </div>
                            <div class="col-2">
                                <date-filter v-model="dates"></date-filter>
                            </div>
                        </div>
                    </div>
                </div>
                <trash-page :items="items"
                            :columns="columns"
                            :recover-item="patchItem"
                            :delete-item="deleteItem"></trash-page>
            </div>
        </div>
    </div>
</template>

<script>
import {modalMixins} from '@/mixins/modal.js'
import {mapActions, mapGetters} from 'vuex';
import DateFilter from "@/components/DateFilter";
import TrashPage from "./TrashTable";

export default {
    mixins: [modalMixins],
    components: {
        TrashPage,
        DateFilter,
    },
    data() {
        return {
            dates: {},
            model: {},
            errors: {},
                tab: null,
                params: {},
                recentColumns: [{
                    label: '',
                    icon: item => {
                        return this.tables[item.resource].icon
                    },
                    field: item => {
                        const columns = this.tables[item.resource].columns;
                        return columns[0].field(item)
                    },
                    subfield: item => {
                        const columns = this.tables[item.resource].columns;
                        if (columns[0].subfield)
                            return columns[0].subfield(item);
                        return ''
                    }
                }]
            };
        },
        computed: {
            ...mapGetters('customers', {findCustomersInStore: 'find'}),
            ...mapGetters('products', {findProductsInStore: 'find'}),
            ...mapGetters('users', {findUsersInStore: 'find'}),
            ...mapGetters('treatment', {findTreatmentsInStore: 'find'}),

            columns() {
                if (!this.tab) return this.recentColumns;
                return this.tables[this.tab].columns
            },

            items() {
                if (!this.tab)
                    return this.recent;
                if (this.tab === 'customers')
                    return this.customers;
                if (this.tab === 'products')
                    return this.products;
                if (this.tab === 'users')
                    return this.users;
                if (this.tab === 'treatments')
                    return this.treatments
            },

            recent() {
                let recent = [
                    ...this.customers,
                    ...this.products,
                    ...this.users,
                    ...this.treatments];
                recent = recent.sort((a, b) => a.updatedAt > b.updatedAt ? -1 : 1);
                return recent.slice(0, 5)
            },


            customers() {
                let data = this.findCustomersInStore(this.params).data;
                return data.map(el => ({...el, resource: 'customers'}))
            },

            products() {
                let data = this.findProductsInStore(this.params).data;
                return data.map(el => ({...el, resource: 'products'}))
            },

            users() {
                let data = this.findUsersInStore(this.params).data;
                return data.map(el => ({...el, resource: 'users'}))
            },

            treatments() {
                let data = this.findTreatmentsInStore(this.params).data;
                return data.map(el => ({...el, resource: 'treatments'}))
            },

            productsCount() {
                return this.findProductsInStore(this.params).total;
            },

            usersCount() {
                return this.findUsersInStore(this.params).total;
            },

            treatmentsCount() {
                return this.findTreatmentsInStore(this.params).total;
            },

            customersCount() {
                return this.findCustomersInStore(this.params).total;
            },


            tables() {
                return {
                    customers: {
                        label: 'Customers', icon: 'fe-users', count: this.customersCount, columns: [{
                            label: '',
                            field: item => {
                                return item.first_name + ' ' + item.last_name
                            },
                            subfield: item => {
                                return item.phone
                            }
                        }]
                    },
                    products: {
                        label: 'Products', icon: 'fe-package', count: this.productsCount, columns: [{
                            label: '',
                            field: item => {
                                return item.label
                            },
                            subfield: item => {
                                let subtitle = '';
                                if (item.category)
                                    subtitle += item.category.label;
                                if (item.brand)
                                    subtitle += '  ' + item.brand.label;
                                return subtitle;
                            }
                        }]
                    },
                    users: {
                        label: 'Team', icon: 'fe-user', count: this.usersCount, columns: [{
                            label: '',
                            field: item => {
                                return item.firstName + ' ' + item.lastName
                            }
                        }]
                    },
                    treatments: {
                        label: 'Services', icon: 'fe-briefcase', count: this.treatmentsCount, columns: [{
                            label: '',
                            field: item => {
                                return item.label
                            },
                            subfield: item => {
                                return item.code
                            }
                        }]
                    }
                }
            }
        },
        watch: {
            dates(newValue) {
                this.fetchAllItems()
            }
        },
        created() {
            this.fetchAllItems();
        },

        methods: {
            ...mapActions('customers', {findCustomers: 'find', patchCustomer: 'patch', deleteCustomer: 'remove'}),
            ...mapActions('products', {findProducts: 'find', patchProduct: 'patch', deleteProduct: 'remove'}),
            ...mapActions('users', {findUsers: 'find', patchUser: 'patch', deleteUser: 'remove'}),
            ...mapActions('treatment', {findTreatments: 'find', patchTreatment: 'patch', deleteTreatment: 'remove'}),


            patchItem(item) {
                if (item.resource === 'customers')
                    return this.patchCustomer;
                if (item.resource === 'users')
                    return this.patchUser;
                if (item.resource === 'treatments')
                    return this.patchTreatment;
                if (item.resource === 'products')
                    return this.patchProduct;
            },

            deleteItem(item) {
                if (item.resource === 'customers')
                    return this.deleteCustomer;
                if (item.resource === 'users')
                    return this.deleteUser;
                if (item.resource === 'treatments')
                    return this.deleteTreatment;
                if (item.resource === 'products')
                    return this.deleteProduct;
            },

            fetchAllItems() {
                let query = {deleted: true, $sort: {updatedAt: -1}};
                if (this.dates.end)
                    query.updatedAt = {$gte: this.dates.start, $lte: this.dates.end};
                this.params = {query};
                this.fetchCustomers();
                this.fetchProducts();
                this.fetchUsers();
                this.fetchTreatments();
            },

            fetchCustomers() {
                this.findCustomers(this.params)
            },

            fetchProducts() {
                this.findProducts(this.params)
            },

            fetchUsers() {
                this.findUsers(this.params)
            },

            fetchTreatments() {
                this.findTreatments(this.params)
            }
        }
    }
</script>
